.root {
	display: flex;
	flex-direction: column;
	gap: var(--space-3);
	height: 100%;
}

.header {
	display: flex;
	align-items: center;
	gap: var(--space-2);
	color: var(--ink-muted);
}

.emoji {
	font-size: 1.1rem;
	line-height: 1;
}

.heading {
	font-weight: 600;
	font-size: 0.9rem;
}

.rows {
	display: flex;
	flex-direction: column;
	gap: var(--space-2);
	min-width: 0;
}

.row {
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	gap: var(--space-3);
	min-width: 0;
}

.rowLabel {
	font-size: 0.75rem;
	font-weight: 600;
	letter-spacing: 0.05em;
	text-transform: uppercase;
	color: var(--ink-muted);
}

.rowMuted .rowLabel {
	opacity: 0.75;
}

.rowValue {
	display: inline-flex;
	align-items: baseline;
	gap: var(--space-2);
}

.count {
	font-size: 1.5rem;
	font-weight: 700;
	line-height: 1;
}

.unit {
	color: var(--ink-muted);
	font-size: 0.8rem;
}

.placeholder {
	color: var(--ink-muted);
	font-style: italic;
}
